import { isEqual, isNil, isNumber, isString } from 'lodash';
import { GeolocationSnapshot } from '@shared/components/blocks/types';
import { EditableField, Field } from './Field';

export class GeolocationField implements EditableField {
  readonly geolocation: GeolocationSnapshot;
  readonly fieldType = 'GeolocationField';

  constructor(geolocation: GeolocationSnapshot) {
    this.geolocation = geolocation;
  }

  validate(): string | null {
    return null;
  }

  isEqual(field: Field): boolean {
    return field instanceof GeolocationField && isEqual(this.geolocation, field.geolocation);
  }

  toFieldJson() {
    return this.geolocation;
  }

  get isEmpty() {
    return isNil(this.geolocation);
  }

  static fromFieldJson(jsonBlob: MBAPI.Scalar.JSON): GeolocationField | null {
    if (isGeolocationSnapshot(jsonBlob)) {
      return new GeolocationField(jsonBlob);
    } else {
      return null;
    }
  }
}

function isGeolocationSnapshot(jsonBlob: MBAPI.Scalar.JSON): jsonBlob is GeolocationSnapshot {
  return (
    !isNil(jsonBlob) &&
    isNumber(jsonBlob.userId) &&
    isString(jsonBlob.date) &&
    isNumber(jsonBlob.accuracy) &&
    isNumber(jsonBlob.coords?.lat) &&
    isNumber(jsonBlob.coords?.lon)
  );
}
